import { compose } from 'redux';

const stubText = (t) => t;

function textConcat(cell) {
  if (cell.name.startsWith('priv_doc_finID')) return stubText;
  if (cell.type === 'string_auto_generated' && cell.cellSet) {
    const { value } = cell.cellSet;
    if (typeof value === 'string' && cell.initValue !== value) {
      return (text) => [value, text].join(' ');
    }
    return stubText;
  }
  return stubText;
}

// eslint-disable-next-line max-len
export function prepareText(cell, data) {
  return {
    ...data,
    payload: {
      ...data.payload,
      text: compose(textConcat(cell))(data.payload.text),
    },
  };
}
